<template>
  <div class="message-box dialog-mask" @click.self="onClose">
    <div class="dialog-box">
      <button class="close-icon" :aria-label="$t('common.close')" @click="onClose">
        <span aria-hidden="true">×</span>
      </button>
      <div class="dialog-body">
        <h1 class="title">{{ title }}</h1>
        <p class="description">
          {{ $t("myPage.emailNotification.completedDialog.description") }}
        </p>
      </div>
      <footer>
        <button class="button close" @click="onClose">
          {{ $t("common.close") }}
        </button>
      </footer>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  props: {
    enabled: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    title() {
      return this.enabled
        ? (this.$t("myPage.emailNotification.completedDialog.receiveTitle") as string)
        : (this.$t("myPage.emailNotification.completedDialog.notReceiveTitle") as string);
    },
  },
  methods: {
    onClose() {
      this.$close(true);
    },
  },
});

interface Props {
  enabled: boolean;
}

interface Data {}

interface Methods {
  onClose: () => void;
}

interface Computed {
  title: string;
}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.dialog-mask {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  z-index: 9000;
  align-items: center;
  justify-content: center;
  background-color: var(--color-overlay);
}

.dialog-box {
  position: relative;
  max-width: 360px;
  width: calc(100% - 32px);
  margin: 10px;
  box-sizing: border-box;
  border-radius: var(--radius-md);
  background-color: var(--color-background-normal);
  box-shadow: var(--shadow-lg);
  color: var(--color-text-normal);
  padding: 28px 24px 20px;
}

.close-icon {
  position: absolute;
  top: 10px;
  right: 12px;
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: var(--font-size-md);
  line-height: 1;
  color: var(--color-text-low);
  padding: 0;
  transition: color 0.15s ease;

  &:hover {
    color: var(--color-text-normal);
  }
}

.dialog-body {
  text-align: left;

  .title {
    margin: 0 0 12px;
    font-size: var(--font-size-md);
    font-weight: var(--font-weight-bold);
    line-height: 1.5;
  }

  .description {
    margin: 0;
    font-size: var(--font-size-sm);
    line-height: 1.6;
    color: var(--color-text-normal);
  }
}

footer {
  display: flex;
  justify-content: stretch;
  margin-top: 18px;
}

.button {
  position: relative;
  width: 100%;
  padding: 12px 20px;
  border: none;
  border-radius: var(--radius-rounded);
  cursor: pointer;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-bold);
}

.button.close {
  background-color: var(--color-surface-base);
  color: var(--color-text-normal);

  @include hover-overlay;
}
</style>
